import React from 'react'
import createClass from 'create-react-class'
import PropTypes from 'prop-types'
import BlockUi from 'react-block-ui'
import {RiseLoader} from 'react-spinners'
import 'react-block-ui/style.css'

const BlockWithLoader = createClass({
  propTypes: {
    loading: PropTypes.bool.isRequired,
    renderChildren: PropTypes.bool,
    className: PropTypes.string,
  },
  render() {
    return (
      <div className={this.props.className}>
        <BlockUi tag="div"
          blocking={this.props.loading}
          loader={<RiseLoader color="#20a8d8" loading={true}/>}
          renderChildren={this.props.renderChildren || false}
          keepInView>
          {this.props.children}
        </BlockUi>
      </div>
    )
  }
})

export default BlockWithLoader



// WEBPACK FOOTER //
// ./src/components/Support/BlockWithLoader.js